import { jsx } from 'panel';
import { SvgIconEl } from 'common/components/svg-icon';
export function template() {
  return jsx("div", {
    sel: '.mp-checkbox-wrapper',
    class: this.helpers.getClasses()
  }, jsx("div", {
    sel: '.mp-checkbox-icon',
    style: this.helpers.getIconStyles()
  }, jsx("div", {
    sel: '.mp-checkbox-animation-layer'
  }), jsx(SvgIconEl, {
    attrs: this.helpers.getIconAttributes()
  })), this.attr("icon") ? jsx("div", {
    sel: '.mp-checkbox-additional-icon'
  }, jsx(SvgIconEl, {
    attrs: {
      icon: this.attr("icon")
    }
  })) : null, jsx("div", {
    sel: '.mp-checkbox-label'
  }, jsx("slot", null)));
}